import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import LoginPage from '../pages/LoginPage';
import MailboxLayout from '../layouts/MailboxLayout';
import InboxPage from '../pages/InboxPage';
import MessagePage from '../pages/MessagePage';
import ThreadPage from '../pages/ThreadPage';
import LiveMessagePage from '../pages/LiveMessagePage';
import LiveThreadPage from '../pages/LiveThreadPage';
import ComposePage from '../pages/ComposePage';
import FolderPage from '../pages/FolderPage';
import ContactsPage from '../pages/ContactsPage';
import SettingsPage from '../pages/SettingsPage';

function RequireAuth({ children }: { children: React.ReactNode }) {
  const { user, loading } = useAuth();
  if (loading) return null;
  if (!user) return <Navigate to="/login" replace />;
  return <>{children}</>;
}

export default function AppRouter() {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route
        path="/"
        element={
          <RequireAuth>
            <MailboxLayout />
          </RequireAuth>
        }
      >
        <Route index element={<Navigate to="/inbox" replace />} />
        <Route path="inbox" element={<InboxPage />} />
        <Route path="folder/:accountId/:folderKey" element={<FolderPage />} />
        <Route path="thread/:threadId" element={<ThreadPage />} />
        <Route path="message/:messageId" element={<MessagePage />} />
        <Route path="imap/thread/:accountId/:folderKey/:threadKey" element={<LiveThreadPage />} />
        <Route path="imap/message/:accountId/:folderKey/:uid" element={<LiveMessagePage />} />
        <Route path="compose" element={<ComposePage />} />
        <Route path="contacts" element={<ContactsPage />} />
        <Route path="settings" element={<SettingsPage />} />
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
